import { SimpleTable } from "@/core/components/simple-table";
import { EmptyTableMessage } from "@volca/ui/components/ui/empty-table-message";
import { ReferralSourcesEmptyState } from "@/business-settings/referral-sources/referral-sources-empty-state";
import { ReferralSource } from "@/referral-sources/referral-source";
import { allCols } from "./cols";

export const ReferralSourcesTable = ({
  data,
  isLoading,
  selectedRowId,
  onRowClick,
  searchValue,
  setSearchValue,
}: {
  data: ReferralSource[];
  isLoading: boolean;
  selectedRowId?: string;
  onRowClick?: (row: ReferralSource) => void;
  searchValue: string;
  setSearchValue: (value: string) => void;
}) => {
  const columns = allCols;

  if (data.length === 0 && !isLoading) {
    return (
      <div className="mr-5 flex h-full min-h-0 flex-col">
        <EmptyTableMessage>
          <ReferralSourcesEmptyState />
        </EmptyTableMessage>
      </div>
    );
  }

  return (
    <SimpleTable
      data={data}
      columns={columns}
      isLoading={isLoading}
      onRowClick={onRowClick}
      selectedRowId={selectedRowId}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
    />
  );
};
